import { createStandardAction } from 'typesafe-actions'

export const setEMailAddress = createStandardAction('@form/email')<string>()
export const setFirstName = createStandardAction('@form/firstName')<string>()
export const setLastName = createStandardAction('@form/lastName')<string>()
export const toggleTerms = createStandardAction('@form/toggleTerms')()
